__webpack_require__.p = "https://assets.homeexchange.com/static/";